import { Box } from "@mui/material";

export function SidenavSeparator() {
  return <Box height={"24px"} />;
}
